import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Chistory(){

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };
   
return(
    <div>
         <Sides/>
         <Helmet>
 
 <title>History and introduction to C programming tutorial For Beginners</title>
 <meta name="description" content="History and introduction to C programming tutorial for beginners.A c programming language developed in 1972 and this c computer language written by a man named Dennis Ritchie.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,history of c language,history of c programming,history of c language in hindi,history of c language pdf,history of c language wikipedia,c language history in hindi,c language history in english,introduction of c programming tutorial" />
 <link rel="canonical" href="https://www.codeexampler.com/c-history" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">History and introduction to C programming
</h1>

<div className="first">
       
<a href="/c-passing-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        </div>

    <p className="mt-4 para">C programming language Developed in 1972, and Dennis Ritchie wrote this c computer language.

</p>
<h2 className="mt-4 mh2">The main point about the introduction of the C programming language:
</h2>
<p className="mt-4 para">The c programming language is a popular language because it is reliable, easy to use, and simple why anybody learns c firstly then comparison to C, C++ means nobody can learn C++ or C directly. Because when you know are advanced compared to c .all points like class, object, polymorphism, etc. At that time, nobody could learn these languages fast, and C, C, or c++ used the Object-Oriented Programming (OOP) principle. 
</p>
<h2 className="mt-4 mh2">Main Points of the introduction of c programming language:
</h2>
<p className="mt-4 para">
C language is a 2 generation programming language.<br/>
A C programming language is a case sensitive language<br/>
C computer language is a middle-level language and top-down approach<br/>
</p>

<h1 className="mt-5">  </h1>
<div className="back">
      
<a href="/c-passing-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        </div>
    </div></div>
)

}
export default Chistory;